import { Component,OnInit} from '@angular/core';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent} from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { TransactionMasterService } from '../fraud-prevention/transaction-master-rule/transaction-master-service';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { Router } from '@angular/router';
import { MenusService } from 'src/app/_services/menu.service';
import {Location} from "@angular/common";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const { defaultPageSizeArr, defaultPageSize } = environment;
export interface OnHoldFilter {
  "pageRecords"?: number;
  "pageNumber"?: number;
  "dateFrom"?: string;
  "dateTo"?: string;
  "status"?: string;
  "processedBy"?: string;
  "senderId"?: string;
}

@Component({
  selector: 'app-onhold-transaction-report',
  templateUrl: './onhold-transaction-report.component.html',
  styleUrls: ['./onhold-transaction-report.component.scss']
})
export class OnholdTransactionReportComponent implements OnInit {

    type:string
    permissions:any
    currentDate: any = new Date();
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public rowData: any = [];
    globalSearch: string = '';
    public defaultColDef: ColDef = {
      flex: 1,
      minWidth: 200,
      resizable: true,
      sortable: true,
      filter: false,
      autoHeight: true
    };
    collectionSize: number = 0;
    pageRecords: number = defaultPageSize;
    pageSizeArr: any = defaultPageSizeArr;
    pageNumber: number = 1;
    isQuickFilter: boolean = false;
    accountData: any = [];
    settlementData: any = [];
    collectiondata: number = 0;
    totalRecords: any;
    status: any;
    processedBy: any;
    public searchFromDate: NgbDateStruct;
    public searchToDate: NgbDateStruct;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    maxDateFrom: NgbDateStruct;
    settlementId: any;
    customerId:any;
    transactionId:any;
    public columnDefs: ColDef[] = [
      {
        field: 'txnId',
        lockVisible: true,
        headerName: 'Tranaction ID',
      },
      {
        field: 'senderUserId',
        lockVisible: true,
        headerName: 'Sender ID'
      },
      {
        field: 'receiverId',
        lockVisible: true,
        headerName: 'Receiver ID'
      },
      {
        field: 'walletId',
        lockVisible: true,
        headerName: 'Sender Wallet ID'
      },
      {
        field: '',
        lockVisible: true,
        headerName: 'Receiver Wallet ID'
      },
      {
        field: 'userMobile',
        lockVisible: true,
        headerName: 'Sender Mobile Number'
      },
      {
        field: 'receiverMobile',
        lockVisible: true,
        headerName: 'Receiver Mobile Number'
      },
      {
        field: 'exchangeRate',
        lockVisible: true,
        headerName: 'FX Rate'
      },
      {
        field: 'channel',
        lockVisible: true,
        headerName: 'Channel'
      },
      {
        field: 'category',
        lockVisible: true,
        headerName: 'Category'
      },
      {
        field: 'mode',
        lockVisible: true,
        headerName: 'Mode'
      },
      {
        field: 'createDate',
        lockVisible: true,
        headerName: 'Timestamp'
      },
      {
        field: 'createDate',
        lockVisible: true,
        headerName: 'Hold Start Time'
      },
       {
        field: 'holdReason',
        lockVisible: true,
        headerName: 'TMS Rule ID'
      },
      {
        field: '',
        lockVisible: true,
        headerName: 'Comment'
      },
      {
        field: 'amount',
        lockVisible: true,
        headerName: 'Amount',
        cellRenderer: PiiCellRendererComponent,
      },
      {
        field: 'status',
        lockVisible: true,
        headerName: 'Status',
        cellRenderer: (params: any) => {
          const status = params.value; // Ensure case-insensitive comparison
          return `<span class="badge badge-warning">${status}</span>`;
        }
  
      },
    ];

    Resultdata: any;
    merchant: any;
    constructor(private alertService: AlertService,private location: Location, private menuService: MenusService, private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter,private transactionService : TransactionMasterService,private router: Router) {
      this.maxDateFrom = this.ngbCalender.getToday();
      this.maxDate = this.ngbCalender.getToday();
    }
  
     async ngOnInit(): Promise<void>{
      // this.getOnHoldReport();
      const path = this.location.prepareExternalUrl(this.location.path());
      console.log(path)
      this.permissions = this.menuService.getPermissions(path);
      console.log(this.permissions)
      if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
     }
    }

  
    getOnHoldReport() {
      const filter: OnHoldFilter = {}
   
      if (this.ngbDateParserFormatter.format(this.searchFromDate) == "" || this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00") {
        filter.dateFrom = "";
      } else {
        filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate);
      }
   
      if (this.ngbDateParserFormatter.format(this.searchToDate) == "" || this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00") {
        filter.dateTo = "";
      } else {
        filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate);
      }
   
      this.transactionService.getOnHoldTransactionReport(this.pageNumber - 1, this.pageRecords, filter.dateFrom, filter.dateTo, this.customerId,this.transactionId,this.type).subscribe((data: any) => {
        console.log(data.response.data.content);
        this.rowData = data.response.data.content;
        this.rowData = data.response.data.content;
        this.collectiondata = data.response.data.content
        this.collectionSize = data.response.data.totalElements
        this.totalRecords = data.response.data.totalElements
        if (data.response.data.content.length == 0) {
          console.log("No data");
          this.alertService.errorAlertWithMessage("No records present");
        }
      })
    }
  
    onFilterChange(param: FilterChangedEvent | any) {
  
    }
  
    onSortChange(event: any) {
      // console.log("==Sort===>", event);
    }
  
    onFilterModified(param: FilterModifiedEvent | any) {
    }
  
    onFilterOpened(param: FilterOpenedEvent | any) {
      // console.log("onFilterOpened----->", param);
    }
  
  
    onGridReady(params: GridReadyEvent) {
      // this.gridApi = params.api;
      // this.gridColumnApi = params.columnApi;
      // this.gridApi.showLoadingOverlay();
      // const allColumnIds: (string | Column)[] = [];
      // params?.columnApi?.getColumns()?.forEach((column) => {
      //   allColumnIds.push(column.getId());
      // });
      // params?.columnApi?.autoSizeColumns(allColumnIds, false);
    }

    getDataByType(type:any){
        this.type = type;
        this.getOnHoldReport();
    }
  
    onPageSizeChanges(eve: any) {
      this.pageNumber = 1;
      this.getOnHoldReport();
    }
  
    onPaginationChange(param: PaginationChangedEvent | any) {
      this.pageNumber = param;
      this.getOnHoldReport();
    }
  
  
  
    private saveAsExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
    }
  
    public exportAsExcelFile(): void {
      const excelFileName: string = 'onhold _report';
      this.getOnHoldReport();
      let tempRec: any = [];
      tempRec = this.columnDefs.filter((col: any) => {
        const column: any = this.gridColumnApi.getColumn(col?.field);
        return column.visible && !(col?.field == "actions")
      });
      let keysToMatch: any = [];
      tempRec.map((col: any) => keysToMatch.push(col.field));
      let jsonData = this.findMatchingObjects(keysToMatch);
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
        header: [...tempRec.map((col: any) => col.headerName)]
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
      XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: 'A2', skipHeader: true });
      XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
  
    findMatchingObjects(keys: string[]): any[] {
      let expData: any = [];
      this.rowData.forEach((curr: any) => {
        const tempRec: any = {}
        keys.forEach((col) => {
          const column: any = this.gridColumnApi.getColumn(col);
          if (column.visible) {
            tempRec[col] = curr[col];
          }
        })
        expData.push(tempRec);
      })
      return expData;
    }
  
    onRowClicked(param: RowClickedEvent | any) {
      // console.log("Row Clicked", param);
    }
  
    onRowDoubleClicked(param: RowClickedEvent | any) {
      // console.log("Row Double Clicked", param);
    }
  
    changeDate() {
      this.currentDate = this.searchFromDate
      this.minDate = this.searchFromDate;
      let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
   
    changeEndDate() {
      this.currentDate = this.searchToDate;
      this.maxDateFrom = this.searchToDate;
    }
  
    resetFilter(): void {
      this.customerId = "";
      this.transactionId = "";
      this.searchFromDate = {year: 0,month: 0,day: 0,};
      this.searchToDate = {year: 0,month: 0,day: 0,};
    }
}
